import { TableCell } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

const useStyles = makeStyles(
  () => ({
    priceCell: {
      borderRight: 'none !important',
    },
  }),
  { name: 'UnitPriceCellHead' },
)

export interface UnitPriceCellHeadProps {
  className?: string
  isEstimate: boolean
}

const UnitPriceCellHead = ({
  className,
  isEstimate,
}: UnitPriceCellHeadProps) => {
  const classes = useStyles()

  if (isEstimate) {
    return null
  }

  return (
    <>
      <TableCell className={classNames(classes.priceCell, className)} />
      <TableCell className={className} />
    </>
  )
}

export default UnitPriceCellHead
